import fetchJSONHandleError from 'utils/NET/fetchJSONHandleError'
import renderLatitudeDetails from './latitudeDetails'
import renderDentalVisionDetails from './dentalVisionDetails'
import getLatitudeBenefits from './getLatitudeBenefits'
import renderCoverageMenu from './coverageMenu'
import renderCoverage from './coverageDetails'
import textContent from 'utils/DOM/textContent'
import getPlanDetails from 'core/services/getPlanDetails'
import addCommissionDisclosure from './addCommissionDisclosure'
import { IS_SHORT_TERM } from 'core/constants/environment'

function getBreakdownMessage(breakdowns, separator) {
  return breakdowns.reduce(
    (accum, current) => `${accum ? accum + separator + current.value : current.value}`,
    ''
  )
}

function showDentalBenefit(benefit) {
  if (benefit.benefitBreakdown) {
    const category = benefit.category
    const breakdown = benefit.benefitBreakdown[0]

    if (category === 'Basic Services') {
      const breakdownMessage = getBreakdownMessage(breakdown, ' | ')

      textContent('.js-benefit-basic', `${breakdownMessage}`)
    } else if (category === 'Major Services') {
      const breakdownMessage = getBreakdownMessage(breakdown, ' | ')
      textContent('.js-benefit-major', `${breakdownMessage}`)
    } else if (category === 'Benefit Year Deductible') {
      const breakdownMessage = getBreakdownMessage(breakdown, '/')

      textContent('.js-benefit-year', `${breakdownMessage}`)
    }
  }
}

function forceCdnAsSource(): boolean {
  const rawItem = sessionStorage.getItem('forceCdnAsSource')
  return rawItem ? JSON.parse(rawItem.toLowerCase()) : false
}

function renderDetails(state) {
  const plan = state.plans[state.planId]
  const dentalPlan = state.plans[state.dentalPlanId]
  const visionPlan = state.plans[state.visionPlanId]
  const latitudePlan = state.plans[state.latitudeId]
  const jsonsToShow = [dentalPlan, visionPlan, latitudePlan].map(
    p => p && p.jsonId && state.jsons[p.jsonId]
  )

  const renderSTMDetails = renderCoverage(state.hcStorage.location.state_acronym)

  const [templateName, planDetailsLoader] = forceCdnAsSource()
    ? [
        'template-static-coverage',
        fetchJSONHandleError({ url: state.jsons[plan.jsonId] })
      ]
    : [
        'template-coverage',
        getPlanDetails(plan.planId, state.hcStorage.location.state_acronym)
      ]

  return Promise.all([
    planDetailsLoader,
    ...jsonsToShow.map(url => url && fetchJSONHandleError({ url }))
  ]).then(
    ([planJson = null, dentalJson = null, visionJson = null, latitudeJson = null]) => {
      const carrierName = state.carriers[plan.carrierId].name

      if (IS_SHORT_TERM) {
        planJson = addCommissionDisclosure(planJson, carrierName)
      }

      const response =
        planJson &&
        renderCoverageMenu(renderSTMDetails({ data: planJson, plan, templateName }))

      if (dentalJson) {
        dentalJson.benefits.forEach(showDentalBenefit)
        renderDentalVisionDetails([dentalJson, visionJson].filter(Boolean))
      }

      if (latitudeJson) {
        const response = getLatitudeBenefits(latitudeJson.membershipBenefits)
        textContent('.js-latitude-membership-benefits', response.membersBenefits)
        textContent('.js-latitude-disclaimer', response.disclaimer)
        renderLatitudeDetails(latitudeJson)
      }

      return response
    }
  )
}

export default renderDetails
